import React from "react";
import { Category, SelectProduct } from "../../../types/salon.types";
import CategoryCard from "../common/CategoryCard";
import ProductCard from "./ProductCard";

interface ProductSectionProps {
  categories?: Category[];
  products: SelectProduct[];
  displayMode?: "grid" | "list";
  onCategorySelect?: (categoryId: string) => void;
  onProductSelect?: (product: SelectProduct) => void;
  selectedProducts?: SelectProduct[];
}

const ProductSection: React.FC<ProductSectionProps> = ({
  categories = [],
  products,
  displayMode = "list",
  onCategorySelect,
  onProductSelect,
  selectedProducts = []
}) => {
  const safeProducts = products || [];
  const safeSelectedProducts = selectedProducts || [];

  // ── LIST MODE: Category selection panel ─────────────────────────────
  if (displayMode === "list") {
    // No product-type categories exist at all → show empty state
    if (categories.length === 0) {
      return (
        <div className="staff-section">
          <h2 className="saloon-title">Categories</h2>
          <div className="staff-container">
            <p className="no-staff">No data available.</p>
          </div>
        </div>
      );
    }

    // Categories exist – always show them, regardless of whether products exist
    return (
      <div className="staff-section">
        <h2 className="saloon-title">Categories</h2>
        <div className="staff-container">
          {categories.map((category) => (
            <CategoryCard
              key={category._id.$oid}
              category={category}
              onClick={() =>
                onCategorySelect && onCategorySelect(category._id.$oid)
              }
            />
          ))}
        </div>
      </div>
    );
  }

  // ── GRID MODE: Product cards after a category is selected ────────────
  return (
    <div className="product-card-details">
      <div className="product-list-container">
        <div className="product-list-header">
          <h2 className="list-title">Products List</h2>
        </div>

        <div className="products-grid">
          {safeProducts.length === 0 ? (
            <p className="no-staff">No data available.</p>
          ) : (
            safeProducts.map(product => {
              const isSelected = safeSelectedProducts.some(p => p._id.$oid === product._id.$oid);
              return (
                <ProductCard
                  key={product._id.$oid}
                  product={product}
                  isSelected={isSelected}
                  onSelect={onProductSelect || (() => {})}
                />
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductSection;
